import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationDashboardRepository } from '../../../infrastructure/repositories/investigation-dashboard.repository';
import { GetInvestigationDashboardWidgetsResult } from './get-investigation-dashboard-widgets.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationDashboardWidgetsUseCase {
  private readonly _repository = inject(InvestigationDashboardRepository);

  public execute(): Observable<GetInvestigationDashboardWidgetsResult> {
    return this._repository.getWidgets().pipe(map((widgets) => ({ widgets })));
  }
}
